require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-yarrabends-newest-release-sells-out-in-three-hours.json") })
        }
      }, "path---news-yarrabends-newest-release-sells-out-in-three-hours");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-yarrabends-newest-release-sells-out-in-three-hours!./.cache/json/news-yarrabends-newest-release-sells-out-in-three-hours.json
// module id = 875
// module chunks = 231608221292675